import {DeleteConfirmModalProps} from 'models/CreatePromotion'

const DynamicModal = ({
 title,
 description,
 onConfirm,
 onCancel,
 textConfirm = 'Yes',
 textCancel = 'No',
}: DeleteConfirmModalProps) => {
 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40'>
   <div className='relative w-[460px] rounded-2xl bg-white p-6 shadow-lg'>
    <button
     onClick={onCancel}
     className='absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100'
    >
     ✕
    </button>

    <h2 className='text-lg font-semibold text-gray-900'>
     {title}
    </h2>

    {description && (
     <p className='mt-2 text-sm text-gray-600'>
      {description}
     </p>
    )}

    <div className='mt-6 flex gap-4'>
     <button
      onClick={onCancel}
      className='flex-1 rounded-lg bg-[#FFEBED] py-2.5 text-sm font-medium  border border-[#CC293F] text-[#CC293F]'
     >
      {textCancel}
     </button>

     <button
      onClick={onConfirm}
      className='flex-1 rounded-lg bg-[#4E83E4] py-2.5 text-sm font-medium text-white '
     >
      {textConfirm}
     </button>
    </div>
   </div>
  </div>
 )
}

export default DynamicModal
